module.exports = __webpack_public_path__ + "img/happy-walking.0979c6ee.png";